import { Container, Typography, Box, Button, Paper } from '@mui/material';
import { Link } from 'react-router-dom';

export default function ConsentRejectedPage() {
  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="h4" color="error" gutterBottom>
          Consent Required
        </Typography>
        <Typography variant="body1" paragraph>
          To use PropertyEarn, you need to accept our cookie and device fingerprinting policy for security purposes.
        </Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          Device fingerprinting helps us protect your account from unauthorized access and fraud.
        </Typography>
        <Button 
          variant="contained" 
          component={Link} 
          to="/login"
          sx={{ mt: 2 }}
        >
          Return to Login
        </Button>
      </Paper>
    </Container>
  );
}